import { createAPI } from '@common'
export default {
  // 获取成员组
  getMemberGroupOptions: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuNfncfsHspvqjoh', 'get', config),
  // 新建会员分组
  createMemberGrouping: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0dsfbufNfncfsHspvqjoh', 'POST', config),
  //修改会员分组
  modifyMemberGrouping: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0npejgzNfncfsHspvqjoh', 'POST', config),
  //设置会员分组
  addUserToRoles: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbdlfoe0beeVtfsUpSpmft', 'POST', config),
  // 读所有站点列表
  getSites: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0tjuft', 'GET', {
      ...config
    }),
  // 获取会员列表
  getMemberList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bmmNfncfsJogp0hfuNfncfsEfubjm/ep',
      'POST',
      config
    ),
  // 获取会员角色列表
  getRoleOptions: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20spmf', 'GET', config),
  // 获取会员列表权限
  getOperationAuth: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuPqfsbujpoBvui', 'POST', config),
  // 会员存疑审核
  auditMemberInfo: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbbt0nfncfs0bvejuNfncfsJogp',
      'GET',
      config
    ),
  // 会员列表-加入黑名单
  addUserToBlacklist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0beeVtfsUpCmbdlmjtu', 'POST', config),
  // 会员列表-移出黑名单
  removeUserFromBlacklist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0sfnpwfVtfsGspnCmbdlmjtu',
      'POST',
      config
    ),
  // 会员列表-大V认证、取消大V
  changeGrantV: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0dibohfHsbouW', 'POST', config),
  // 会员分组拖拽排序
  sortMemberGrouping: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0tpsuNfncfsHspvqjoh', 'POST', config),
  // 会员分组删除
  deleteMemberGrouping: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0efmfufNfncfsHspvqjoh', 'POST', config),
  // 获取学科
  getProfession: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tnbsu0wpdbc0qspgfttjpo', 'GET', config),
  // 会员管理流程记录
  getOperationLogs: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuPqfsbujpoMpht', 'GET', config),
  // 获取角色下拉选项列表
  getRoleList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20spmf', 'GET', config),
  //  账号校验:账号：系统唯一字段值，新建时需进行判重  看是否需要在输入时及时校验，还是放在调保存接口时校验并给提示？？
  checkLoginName: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0difdlMphjoObnf/ep', 'GET', config),
  // 手机号校验
  checkMobileExist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbbt0nfncfs0difdlNpcjmfFyjtu',
      'GET',
      config
    ),
  // 邮箱校验
  checkEmailExist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbbt0nfncfs0difdlFnbjmFyjtu',
      'GET',
      config
    ),
  // 昵称校验
  checkNickNameExist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0difdlOjdlObnfFyjtu', 'GET', config),
  //新建会员
  addCreateMember: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bmmNfncfsJogp0feju', 'POST', config),
  //注销会员
  changeUserNoUse: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbdlfoe0dibohfVtfsOpVtf', 'POST', config),
  //禁用会员
  deleteMember: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0efmfufNfncfs', 'GET', config),
  //启用会员
  restoreMember: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbbt0nfncfs0sftupsf/ep', 'GET', config),
  //  获取设置的命名规则
  getNickName: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuOjdlObnf', 'GET', config),
  //设置命名规则
  saveNickName: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0tbwfOjdlObnf', 'POST', config),
  //导出会员
  exportMembers: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0fyqpsuNfncfst', 'POST', config),
  //下载错误文件
  downErrorFIle: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0epxompbeGjmf', 'POST', config),
  // 获取会员导出列表
  getExportMembersFileList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuFyqpsuNfncfstGjmfMjtu',
      'GET',
      config
    ),
  // 下载会员导出列表文件
  downloadTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0epxompbeUfnqmbuf', 'GET', config),
  // 下载虚拟会员导出列表文件
  downloadVirtualMemberTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0epxompbeWjsuvbmNfncfsUfnqmbuf',
      'GET',
      config
    ),
  //删除下载记录
  deleteFile: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0efmfufGjmf', 'POST', config),
  // 获取详情页会员分组
  getUserRoleByUserId: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuVtfsSpmfCzVtfsJe', 'GET', config),
  // 获取详情页未加密手机号
  getDecryptMobileByUserId: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuEfdszquNpcjmfCzVtfsJe',
      'GET',
      config
    ),
  // 查询会员登录日志列表
  getLoginLogs: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20cbdlfoe0hfuMphjoMpht', 'GET', config),
  // 查询会员积分记录列表
  getPointsTransaction: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfs`bmm`qpjout`usbotbdujpo',
      'GET',
      config
    ),
  //获取邀请码列表
  getInvitecodeList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0tfbsdi', 'POST', config),
  //邀请码导出列表
  exportInvitecodeList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0fyqpsuCzTfbsdi', 'POST', config),
  //下载当前二维码
  downloadInvitecode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0epxompbeCzTfbsdi',
      'POST',
      config
    ),
  //删除当前二维码
  deleteInvitecode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0efmfuf', 'PUT', config),
  //查询积邀请码激活明细
  searchRecordList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0tfbsdiSfdpseMjtu',
      'POST',
      config
    ),
  //批量生成二维码-检查当前单位代码已生成数量
  getCreateBatchInfo: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0hfuDsfbufCbudiJogp',
      'POST',
      config
    ),
  //批量生成二维码
  createBatch: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0dsfbufCbudi', 'POST', config),
  //导出邀请码激活明细
  exportRecordList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20jowjufdpef0fyqpsuSfdpseMjtu',
      'POST',
      config
    ),
  // 查询会员等级列表
  getExperienceLevelList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfs`fyqfsjfodf0hfuFyqfsjfodfMfwfmMjtu',
      'GET',
      config
    ),
  //新建会员等级
  createExperienceLevel: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfs`fyqfsjfodf0dsfbufFyqfsjfodfMfwfm',
      'POST',
      config
    ),
  //修改会员等级
  modifyExperienceLevel: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfs`fyqfsjfodf0npejgzFyqfsjfodfMfwfm',
      'POST',
      config
    ),
  //删除会员等级
  deleteExperienceLevel: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfs`fyqfsjfodf0efmfufFyqfsjfodfMfwfm',
      'POST',
      config
    ),
  // 会员积分--查询会员积分列表
  getPointsRuleList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf', 'GET', config),
  //会员积分--新建积分规则
  createPointsRule: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf', 'POST', config),
  // 会员积分-获取七日签到详情
  getContinuousSignConfig: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf0cbdlhspvoe0dpoujovpvtTjhoDpogjh',
      'GET',
      config
    ),
  //会员积分-编辑七日签到
  postContinuousSignConfig: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf0dpoujovpvtTjhoDpogjh',
      'POST',
      config
    ),
  //会员积分- state 启用 = 1 禁用 = 0
  putPointsRule: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf', 'PUT', config),
  // 会员积分-- 移动  type 上移=1 下移=2
  movePointsRule: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf0npwf', 'GET', config),
  //会员积分-- 删除积分
  deletePointsRule: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20qpjout`svmf', 'Delete', config),
  // 会员积分-- 查看积分日志
  getRuleEditLogByRuleType: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0nfncfsMph0FyqfsjfodfQpjou0hfuSvmfFejuMphCzSvmfUzqf/ep',
      'GET',
      config
    ),
  // 短信对接配置 -- 获取短信平台下拉列表
  getTypeList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20uzqfMjtu0|uzqf~', 'GET', {
      ...config,
      pathParams: { type: config.params.type }
    }),
  // 短信对接配置 -- 获取短信对接配置列表
  getMaskedPageList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20hfuNbtlfeQbhf', 'GET', config),

  // 查询短信配置列表
  getMessagePage: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20hfuQbhf', 'get', config),
  // 新增短信配置
  addMessage: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w2', 'post', config),
  // 获取短信配置信息
  getEncryptedInfo: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20hfuFodszqufeJogp', 'get', config),
  // 修改短信配置
  editMessage: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20|je~', 'get', {
      ...config,
      pathParams: { id: config.params.id }
    }),
  // 删除短信配置
  deleteMessage: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20|je~', 'delete', {
      ...config,
      pathParams: { id: config.params.id }
    }),
  // 禁用、启用短信配置
  putMessage: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20|je~0tubuvt0|tubuvt~0|ovn~',
      'put',
      {
        ...config,
        pathParams: {
          id: config.params.id,
          status: config.params.status,
          num: config.params.num
        }
      }
    ),
  // 短信 会根据短信平台的切换 获取更新的form参数
  getConfigList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0tfoefs0w20dpogjh0|uzqf~', 'get', {
      ...config,
      pathParams: { type: config.params.type }
    }),
  // 查询短信模版列表
  getMessageTemplatePage: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w20hfuNbtlfeQbhf', 'get', config),
  // 新增短信模版配置
  addMessageTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w2', 'post', config),
  // 获取短信配置信息
  getMessageTemplateInfo: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w20hfuFodszqufeJogp',
      'get',
      config
    ),
  // 修改短信模版配置
  editMessageTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w20|je~', 'get', {
      ...config,
      pathParams: { id: config.params.id }
    }),
  // 删除短信模版配置
  deleteMessageTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w20|je~', 'delete', {
      ...config,
      pathParams: { id: config.params.id }
    }),
  // 禁用、启用短信模版配置
  putMessageTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w20|je~0tubuvt0|tubuvt~0|ovn~',
      'put',
      {
        ...config,
        pathParams: {
          id: config.params.id,
          status: config.params.status,
          num: config.params.num
        }
      }
    ),
  // 短信 会根据短信平台的切换 获取更新的form参数
  getTemplateConfigList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0ufnqmbuf0w20dpogjh0|uzqf~', 'get', {
      ...config,
      pathParams: { type: config.params.type }
    }),
  // 获取验证码
  getValidateImageCode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf00wfsjgz0hfuWbmjebufJnbhfDpef',
      'get',
      config
    ),
  // 发送短信
  verifySmsSend: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf00wfsjgz0tntTfoe', 'post', config),
  // 短信对接配置-获取号码黑名单列表
  searchBlackList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0qipof.ovn.cmbdlmjtu0w20tfbsdiCmbdlMjtu',
      'get',
      config
    ),
  // 短信对接配置-号码黑名单列表-查看原始号码
  getOriginalPhoneNum: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0qipof.ovn.cmbdlmjtu0w20hfuPsjhjobmQipofOvn',
      'get',
      config
    ),
  // 短信对接配置-号码黑名单列表-新建
  addToBlacklist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0qipof.ovn.cmbdlmjtu0w20beeUpCmbdlmjtu',
      'post',
      config
    ),
  // 短信对接配置-号码黑名单列表-删除
  removeFromBlacklist: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0qipof.ovn.cmbdlmjtu0w20sfnpwfGspnCmbdlmjtu',
      'post',
      config
    ),
  // 短信对接配置-号码黑名单列表-获取黑名单机制
  getBlacklistConfig: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0qipof.ovn.cmbdlmjtu0w20hfuCmbdlmjtuDpogjh',
      'get',
      config
    ),
  // 短信对接配置-号码黑名单列表-设置黑名单机制
  saveBlacklistConfig: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0qipof.ovn.cmbdlmjtu0w20tbwfCmbdlmjtuDpogjh',
      'post',
      config
    ),
  // 付费会员模块接口
  //付费会员设置
  postPayMemberConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qbzNfncfs0dpogjh', 'post', config),
  //付费会员配置查询
  getPayMemberConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qbzNfncfs0dpogjh', 'get', config),
  // 会员套餐列表
  getMemberPlanList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsQmbo0mjtu', 'POST', config),
  // 保存会员套餐
  saveMemberPlan: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsQmbo0tbwf', 'POST', config),
  // 会员套餐详情
  getMemberPlanDetail: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsQmbo0efubjm', 'GET', config),
  // 停用套餐
  forbiddenMemberPlan: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsQmbo0gpscjeefo', 'put', config),
  // 启用套餐
  enableMemberPlan: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsQmbo0fobcmf', 'put', config),
  // 套餐更新排序
  updateOrderMemberPlan: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsQmbo0vqebufPsefs', 'POST', config),
  // 订单管理列表
  getMemberOrderList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsPsefs0mjtu', 'POST', config),
  // 订单管理列表导出
  exportMemberOrder: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsPsefs0fyqpsu', 'POST', config),
  // 兑换码列表列表
  getMemberExchangeCodeList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsFydibohfDpef0mjtu', 'POST', config),
  // 新建兑换码
  saveMemberExchangeCode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsFydibohfDpef0tbwf', 'POST', config),
  // 兑换码启用/停用
  updateMemberExchangeCodeStatus: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsFydibohfDpef0vqebufTubuvt',
      'POST',
      config
    ),
  // 兑换码使用
  useMemberExchangeCode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsFydibohfDpef0vtf', 'POST', config),
  // 兑换码导出
  exportMemberExchangeCode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20nfncfsFydibohfDpef0fyqpsuCzTfbsdi',
      'POST',
      config
    )
}
